module.exports = __webpack_public_path__ + "static/media/ribbon.2852c5b4.svg";